var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeStarHovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 66,
    viewBox: "0 0 64 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.178 9.68436C36.7973 2.89991 27.2027 2.89991 24.822 9.68436L20.7314 21.3418L9.15771 25.8579C2.70193 28.377 2.70189 37.5122 9.1577 40.0313L20.7313 44.5474L24.822 56.2048C27.2027 62.9893 36.7973 62.9893 39.178 56.2048L43.2686 44.5474L54.8423 40.0313C61.2981 37.5122 61.2981 28.377 54.8423 25.8579L43.2686 21.3418L39.178 9.68436ZM43.1005 21.2762C43.1007 21.2762 43.1008 21.2763 43.101 21.2764L43.1005 21.2762ZM43.3284 21.5121L43.328 21.5108C43.3281 21.5112 43.3283 21.5116 43.3284 21.5121L42.9577 21.6422L43.3284 21.5121Z",
    fill: "#FF8D5E",
    stroke: "#AA3B82",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeStarHovered);
export default __webpack_public_path__ + "static/media/orangeStarHovered.8cd7182fd0f9608b0cbfa3d6082ca584.svg";
export { ForwardRef as ReactComponent };